/**
 *    @author: Andrew Sheen
 *    @since:  2020-10-30
 *    @see:    FormBaseComponent
 */

export abstract class IValidator {
       abstract validate():boolean;
       public IdOfChanged():number {
             return 0;
       }
}

